
import $apis from '@/request/apis';
import $tool from '@/utils/tool'

//微信分享
// 初始化之后 配置 wxShareCom.init({
// title: '', // 分享标题
// desc: '', // 分享描述
// link: '', // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
// imgUrl: '', // 分享图标
// })

let wxShareCom = {

    wxConfig: {
        weChatId: 93231,
        appId:'',
        signature:'',
        timestamp:'',
        nonceStr:'',
        jsApiList:['updateAppMessageShareData','updateTimelineShareData', 'scanQRCode', 'hideMenuItems'],
        isDisabledShare: false

    },

    shareConfig: {
        title: '', // 分享标题
        desc: '', // 分享描述
        link: '', // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
        imgUrl: '', // 分享图标
        success() {}, //设置成功后调用，注意不是分享后，或点击分享按钮调用。
    },

    //获取微信配置
    async getWxConfig() {

        let url = '/weChat/getConfig';
        let parainfo = {
            'weChatId': this.wxConfig.weChatId,
            'url':window.location.href,
            'jsApiList': this.wxConfig.jsApiList,
            'onDebug': false,
            "_cache_with_cached": 1, //是否启用缓存 0/1
            "_cache_refresh": 0, //是否刷新缓存 0/1
            "_cache_timeout": 5*60, //缓存过期时间【秒】
        };

        let wxConfig = await $apis.getWxConfig(parainfo);
        console.log(wxConfig)

        this.wxConfig.appId = wxConfig.body.content.appId;
        this.wxConfig.signature = wxConfig.body.content.signature;
        this.wxConfig.timestamp = wxConfig.body.content.timestamp;
        this.wxConfig.jsApiList = wxConfig.body.content.jsApiList;
        this.wxConfig.nonceStr = wxConfig.body.content.nonceStr;

        this.setWxConfig();

    },

    //设置微信配置
    setWxConfig() {
        let _this = this;
        wx.config({
            debug: false, // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印。
            appId: _this.wxConfig.appId, // 必填，公众号的唯一标识
            timestamp: _this.wxConfig.timestamp, // 必填，生成签名的时间戳
            nonceStr: _this.wxConfig.nonceStr, // 必填，生成签名的随机串
            signature: _this.wxConfig.signature,// 必填，签名
            jsApiList: _this.wxConfig.jsApiList // 必填，需要使用的JS接口列表
        });

        _this.setShare();
    },

    //设置分享
    setShare() {
        wx.ready(() => {   //需在用户可能点击分享按钮前就先调用
            // 禁用分享
            if(this.wxConfig.isDisabledShare){
                wx.hideOptionMenu();
                return;
            }

            //自定义“分享给朋友”及“分享到QQ”按钮的分享内容
            wx.updateAppMessageShareData({
                title: this.shareConfig.title, // 分享标题
                desc: this.shareConfig.desc, // 分享描述
                link: this.shareConfig.link, // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
                imgUrl: this.shareConfig.imgUrl, // 分享图标
                success: this.shareConfig.returnFunc
            });

            // 自定义“分享到朋友圈”及“分享到QQ空间”按钮的分享内容
            wx.updateTimelineShareData({
                title: this.shareConfig.title, // 分享标题
                link: this.shareConfig.link, // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
                imgUrl: this.shareConfig.imgUrl, // 分享图标
                success: this.shareConfig.returnFunc
            });
        });
    },

    //处理分享链接，解决加参数失效的问题
    handelUrl(){
        if(this.shareConfig.link.indexOf('?') > -1){
            this.shareConfig.link = this.shareConfig.link + '&from=singlemessage&isappinstalled=0';
        }else{
            this.shareConfig.link = this.shareConfig.link + '?from=singlemessage&isappinstalled=0';
        }
    },

    init(shareInfo) {
        if(!$tool.isWx){
            return;
        }
        this.wxConfig.isDisabledShare = shareInfo.isDisabledShare || false;
        this.shareConfig = shareInfo;
        this.handelUrl();
        this.getWxConfig();
    }
};

export default wxShareCom
